/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Image from './Image';

import styles from '../../../styles/partials/poster.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    className: PropTypes.string,
    isDark: PropTypes.bool,
};

const defaultProps = {
    item: null,
    className: null,
    isDark: false,
};

const Poster = ({ item, className, isDark }) => {
    const { title = null, poster = null, image = null } = item || {};
    const { colors = null } = poster || image || {};
    const [fromColor = null, toColor = null] = colors || [];

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isDark]: isDark,
                    [className]: className !== null,
                },
            ])}
        >
            {poster === null ? (
                <div
                    className={styles.fallback}
                    style={
                        fromColor !== null && toColor !== null
                            ? {
                                  backgroundImage: `linear-gradient(to bottom, ${fromColor} 30%, ${toColor} 100%)`,
                              }
                            : null
                    }
                >
                    {image !== null ? (
                        <Image
                            className={styles.fallbackPoster}
                            imageClassName={styles.fallbackImage}
                            media={image}
                            mediaSize="medium"
                            fit
                            cover
                            lazy
                        />
                    ) : null}
                    <div className={styles.fallbackLabel}>
                        {title !== null && (
                            <h2
                                className={classNames([
                                    styles.fallbackTitle,
                                    {
                                        [styles.alone]: image === null,
                                    },
                                ])}
                            >
                                {title}
                            </h2>
                        )}
                    </div>
                </div>
            ) : null}
            {poster !== null ? (
                <Image
                    className={styles.poster}
                    imageClassName={styles.image}
                    media={poster}
                    mediaSize="medium"
                    fit
                    cover
                />
            ) : null}
        </div>
    );
};

Poster.propTypes = propTypes;
Poster.defaultProps = defaultProps;

export default Poster;
